<!-- eslint-disable-next-line agentic/no-single-template-wrapper -->
<div class="wrapper">
    <div class="visual">
        @if (visualImage(); as stateImage) {
            <img
                class="image"
                loading="eager"
                [ngSrc]="stateImage.src"
                [attr.srcset]="stateImage.srcset ?? null"
                [alt]="stateImage.alt"
                [height]="stateImage.height"
                [width]="stateImage.width"
                [placeholder]="stateImage.placeholder ?? false"
                disableOptimizedSrcset
            />
        } @else {
            <ng-icon qpx size="lg" context="destructive" [name]="icon()" />
        }
    </div>

    <div class="content">
        <h3 qpxModalTitle class="title">{{ heading() }}</h3>

        <p qpxBody="secondary" tone="muted" class="description">
            {{ error()?.detail ?? 'Something went wrong' }}
        </p>

        <ng-content />
    </div>
</div>
